"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./LogoGarden.css");

var _react = _interopRequireDefault(require("react"));

var _map = _interopRequireDefault(require("lodash/map"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _logoData = _interopRequireDefault(require("../data/logoData"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogoGarden = function LogoGarden(_ref) {
  var _ref$logos = _ref.logos,
      logos = _ref$logos === void 0 ? _logoData.default : _ref$logos;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "logo-garden"
  }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
    className: "logo-header",
    tag: "h5",
    contentKey: "logoGardenHeader"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "logo-images"
  }, (0, _map.default)(logos, function (_ref2, i) {
    var src = _ref2.src,
        alt = _ref2.alt;
    return /*#__PURE__*/_react.default.createElement("img", {
      className: "logo",
      key: alt + i,
      src: src,
      alt: alt
    });
  })));
};

LogoGarden.propTypes = {
  logos: _propTypes.default.arrayOf(_propTypes.default.shape({
    src: _propTypes.default.string,
    alt: _propTypes.default.string
  }))
};
var _default = LogoGarden;
exports.default = _default;